<template>
	<div class="exam">
		<div class="main">
			<div class="headers"><Header /></div>
			<div class="mian-body">
				<div class="main-side">
					<div class="title">
						<div class="title_border"></div>
						<div class="title_content">答题卡</div>
					</div>
					<div class="card-content-list">
						<div class="card-content">
							<div class="card-content-title">(共{{ dataLists.length }}题，合计{{ exminxslistobjs.SPA_Scores }}分)</div>
							<div class="box-list">
								<div class="box normal-box question_cbox" v-for="(item, index) in dataLists" @click="scrollview(index)" :key="index">
									<div class="checki" :class="{ checked: item.isopsanswers == 1 }">{{ index + 1 }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="main-center">
					<div class="body-wrapper">
						<div class="questions">
							<div class="questions-title">共{{ dataLists.length }}题，合计{{ exminxslistobjs.SPA_Scores }}分</div>
							<div class="questions-content">
								<div class="question-content" v-for="(item, i) in dataLists" :key="i" :ref="'text' + i" :id="'text' + i">
									<div v-if="item.SQT_Name == '判断题'">
										<div class="exam-question">
											<p class="exam-pd" v-if="item.SQT_Name == '判断题'">{{ item.SQT_Name }}</p>
											<span class="question-index ellipsis">{{ i + 1 }}.</span>
											{{ item.SQB_Question }}
										</div>
										<div>
											<div class="answers" v-for="(son, index) in item.Questionoptions" :key="index" @click="getIputValue(item, son, i, index)">
												<!-- <el-radio v-model="radio[index]" :label="son.SQB_Question"  >{{ son.value=="A"?'对':'错' }}</el-radio> -->
												<div class="answersqust">
													<p
														class="clicrs"
														:style="{ background: son.isOptionAnswer == 1 ? '#5fbd9a' : '', color: son.isOptionAnswer == 1 ? '#fff' : '' }"
													>
														{{ son.value }}
													</p>
													<p>{{ son.SQO_OptionName }}</p>
												</div>
											</div>
										</div>
									</div>

									<div v-if="item.SQT_Name == '多选题'">
										<div class="exam-question">
											<p class="exam-dxt" v-if="item.SQT_Name == '多选题'">{{ item.SQT_Name }}</p>
											<span class="question-index ellipsis">{{ i + 1 }}.</span>
											{{ item.SQB_Question }}
										</div>
										<div>
											<div class="answers" v-for="(son, index) in item.Questionoptions" :key="index" @click="getIputValue(item, son, i, index)">
												<!-- <el-radio v-model="radio[index]" :label="son.SQB_Question"  >{{ son.value=="A"?'对':'错' }}</el-radio> -->
												<div class="answersqust">
													<p
														class="clicrs"
														:style="{ background: son.isOptionAnswer == 1 ? '#5fbd9a' : '', color: son.isOptionAnswer == 1 ? '#fff' : '' }"
													>
														{{ son.value }}
													</p>
													<p>{{ son.SQO_OptionName }}</p>
												</div>
											</div>
										</div>
									</div>

									<div v-if="item.SQT_Name == '单选题'">
										<div class="exam-question">
											<p class="exam-dxtt" v-if="item.SQT_Name == '单选题'">{{ item.SQT_Name }}</p>
											<span class="question-index ellipsis">{{ i + 1 }}.</span>
											{{ item.SQB_Question }}
										</div>
										<div>
											<div class="answers" v-for="(son, index) in item.Questionoptions" :key="index" @click="getIputValue(item, son, i, index)">
												<!-- <el-radio v-model="radio[index]" :label="son.SQB_Question"  >{{ son.value=="A"?'对':'错' }}</el-radio> -->
												<div class="answersqust">
													<p
														class="clicrs"
														:style="{ background: son.isOptionAnswer == 1 ? '#5fbd9a' : '', color: son.isOptionAnswer == 1 ? '#fff' : '' }"
													>
														{{ son.value }}
													</p>
													<p>{{ son.SQO_OptionName }}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="main-right">
					<div class="nav">
						<ul v-show="!checkResult">
							<li class="menu-item">
								<div class="item-label">剩余时间</div>
								<div class="item-data"><Time @show="handInHand" :status="submitView" :examtime="examtime" v-if="examtime != ''"></Time></div>
							</li>
							<li class="menu-item">
								<div class="item-label">当前进度</div>
								<div class="item-press">
									<span>{{ radio.filter(v => v).length }}</span>
									<span>{{ dataLists.length }}</span>
								</div>
								<div class="percentage"><el-progress :percentage="percentage" :color="customColor"></el-progress></div>
							</li>
						</ul>
					</div>
					<div class="btn" v-show="!checkResult" @click="submit">提交</div>
				</div>
			</div>
		</div>

		<!-- <el-dialog title="我的考试列表" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
			<div class="exminrlist">
				<div
					class="exminritems"
					v-for="(item, index) in exminxslist"
					:key="item.SPA_GUID"
					:style="{ 'border-color': item.isexmins == 1 ? '#4de7e7' : '' }"
					@click="changeexminitem(item)"
				>
					<p class="exminrp">{{ item.SPA_PaperTitle }}</p>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<p>
							<span class="el-icon-menu"></span>
							总题目数：{{ item.SPA_JudgeCount + item.SPA_MultiCount + item.SPA_SingleCount }}
						</p>
						<p>
							<span class="el-icon-time"></span>
							考试时间：{{ item.SPA_Duration }}
						</p>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer"><el-button type="primary" @click="dialogexminx">确 定</el-button></span>
		</el-dialog> -->
	</div>
</template>

<script>
import AppOptions from '@/config/AppOptions.vue';

import Header from '@/components/header/Header.vue';
import Time from '@/components/module/Time'; // 倒计时组件
import { PaperDetailsjs, setAjaxScoring, getGetQuetype ,
KsScoringTestQuestions

} from '@/request/api/homesview/yunhomes/yunhom.js';

import { uniqueFunc } from '@/utils/utils';

export default {
	data() {
		return {
			checkData: [],
			checking: false,
			name: '',
			examtime: '',
			title: '',
			customColor: '#55b6da',
			percentage: 0,
			submitView: false,
			full_score: '',
			signView: false, // 正确与错误
			passView: false, // 通过或者未通过
			checkResult: false, // 左侧栏、右侧栏、答题结果栏
			options: [
				{
					value: '0',
					label: '全部'
				},
				{
					value: '1',
					label: '答对'
				},
				{
					value: '2',
					label: '答错'
				}
			],
			checkVal: '0',
			examinationData: '',
			allRadio: [], //提交给后台的真题数据
			radio: [], //单选真题答案,
			checkLen: [],
			obj: { value: '' },
			answersData: [],
			// 弹窗
			dialogVisible: false,
			exminxslist: [],
			exminxslistobj: null,
			exminxslistobjs: {},
			// 试题列表
			dataLists: [],
			ListModels: [],
			// 点击交卷不用提示直接退出
			iseaminmroe: false,
			starttimer: '',
			quetype: []
		};
	},
	watch: {},
	created() {
		AppOptions.appEmpty = true;
		
	},

	mounted() {
		this.name = '考试';
		this.get();
	},

	methods: {
		// 获取考试题
		get() {
			getGetQuetype().then(ress => {
				this.quetype = ress.data.data;
			});
			this.dialogexminx();
		},
		// 点击滑动
		scrollview(i) {
			let domsg = eval('this.$refs.text' + i)[0];
			domsg.scrollIntoView({
				behavior: 'smooth', // 平滑过渡
				block: 'start' // 上边框与视窗顶部平齐
			});
			// console.log(domsg);
		},
		// 点击当选或者多选
		changeexminitem(item) {
			// console.log("考试",item)
			this.exminxslistobj = item;

			let exminxslist = Array.from(this.exminxslist);
			exminxslist.forEach(ite => {
				if (item.SPA_GUID == ite.SPA_GUID) {
					ite.isexmins = 1;
				} else {
					ite.isexmins = 0;
				}
			});
			this.exminxslist = exminxslist;
		},
		formatFullTime(timestamp, format = 'YYYY-MM-DD h:m:s') {
			var date = new Date(timestamp);
			var Y = date.getFullYear();
			var M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
			var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
			var h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
			var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
			var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
			return format
				.replace('YYYY', Y)
				.replace('MM', M)
				.replace('DD', D)
				.replace('h', h)
				.replace('m', m)
				.replace('s', s);
		},
		dialogexminx() {
			let exminxslistobj = {
				SPA_GUID:this.$route.query.SPA_GUID
			};
			PaperDetailsjs(exminxslistobj).then(res => {
				if (res.data.code >= 0) {
					this.starttimer = this.formatFullTime(new Date(), 'YYYY-MM-DD h:m:s');

					// console.log(res.data.data)
					let dataLists = [];
					// 判断
					res.data.data.JudgeOptionlist.forEach(item => {
						dataLists.push(item);
					});

					// 多选
					res.data.data.MultipleOptionlist.forEach(item => {
						dataLists.push(item);
					});

					// 单选
					res.data.data.SingleOptionlist.forEach(item => {
						dataLists.push(item);
					});

					// this.exminxslistobjs = exminxslistobj;
					this.examtime = this.toHHmmss(60000 * 90);
					this.dataLists = dataLists;
					this.exminxslistobjs.SPA_GUID = res.data.data.SPA_GUID;
					this.getdataLists();
				}
			});
		},
		getdataLists() {
			// abc数组主要是数据里面没有abc，所以我在每一个数据都添加一个abc的值，用来渲染和判断
			let chioceszm = ['A', 'B', 'C', 'D', 'F', 'E', 'G', 'H', 'I', 'j', 'K', 'L'];

			this.dataLists.forEach((item, index) => {
				// 这里是加题型
				this.quetype.forEach(itm => {
					if (itm.SQT_GUID == item.SQT_GUID) {
						item.topicType = itm.SQT_Name;
						item.SQT_Name = itm.SQT_Name;
					}
				});
				// 这里是加前面的题目号
				item.SQB_Quesion = index + 1 + '、' + item.SQB_Question;
				// 这个好像也是加题目号用的我忘记了
				item.numstrst = index + 1;
				// 初始化判断值，他为true说明状态为选中的
				item.answerResult = false;
				item.isopsanswers = 0;
				// 这里添加，初步判断多选不可能超过12，如果有这种多选那么自行添加
				item.Questionoptions.forEach((itm, idx) => {
					itm.value = chioceszm[idx];
					itm.isOptionAnswer = 0;
				});
			});
			// console.log(this.dataLists)
		},
		// 退出
		handleClose(done) {
			this.$confirm('暂不支持退出页面，请选择试卷？')
				.then(_ => {})
				.catch(_ => {});
		},
		// 退出考试系统
		esc() {
			this.$router.push({
				path: '/'
			});
		},
		// 主动交卷
		submit() {
			this.$confirm('确定交卷吗?', '提示', {
				distinguishCancelAndClose: true,
				confirmButtonText: '交卷',
				cancelButtonText: '不交卷',
				type: 'warning'
			})
				.then(() => {
					this.upAnswer();
				})
				.catch(err => {
					// console.log(err);
				});
		},
		// 自动交卷（时间到）
		handInHand() {
			this.upAnswer();
			// this.signView = true; // 正确与错误
			// this.passView = true; // 通过或者未通过
			// this.checkResult = true; // 左侧栏、右侧栏、答题结果栏
		},
		// 提交答案接口
		upAnswer() {
			// console.log('提交答案');
			this.dataLists.forEach(ia => {
				if (ia.answermoadobj) {
					this.ListModels.push(ia.answermoadobj);
				}
			});
			this.iseaminmroe = false;

			let dataLists = [];
			let ListModel = [];
			let that = this;

			// console.log('提交答案', this.dataLists);
			this.dataLists.forEach(ib => {
				let answermoadobj = {};
				answermoadobj.SQB_GUID = ib.SQB_GUID;
				answermoadobj.SQO_GUID = '';
				// answermoadobj.SQT_TYPE = ib.topicType;
				answermoadobj.SQT_GUID = ib.SQT_GUID;
				// answermoadobj.SQO_IsChecked = '';
				// console.log('难道没有到这里', answermoadobj);
				var lg = this.ListModels.filter(s => s.SQB_GUID == ib.SQB_GUID).length;

				if (lg > 0) {
					let moadobj = this.ListModels.find(v => v.SQB_GUID == ib.SQB_GUID);
					answermoadobj.SQO_GUID = moadobj.SQO_GUID;
					// answermoadobj.SQO_IsChecked = moadobj.SQO_IsChecked;
				}

				ListModel.push(answermoadobj);
			});
			// console.log(ListModel.length,this.dataLists.length);
			if(ListModel.length<this.dataLists.length){
				this.$message('请完成题目填写！');
				return
			}
			
			
			//  JSON.stringify(ListModel)
			var data1 = {
				SPA_GUID: this.exminxslistobjs.SPA_GUID,
				Stime: this.starttimer,
				listQuestion: ListModel
			};
			// console.log(data1,"提交")
			
			// return
			KsScoringTestQuestions(data1).then(res => {
				// console.log(res.data)
				if (res.data.code >= 0) {
					this.$message.success(res.data.msg);
					this.$router.go(-1);

					return;
				}
				// this.$message(res.data.msg);
			});
		},

		// 倒计时处理
		madeTime(serverTime1, begin1, duration1) {
			var serverTime = new Date(serverTime1); // 系统时间
			var duration = duration1; //考试时间
			if (begin1 != null) {
				var begin = new Date(begin1); //开始时间
				var residue = begin.getTime() + duration * 1000 - serverTime.getTime(); // 倒计时
			} else {
				// eslint-disable-next-line no-redeclare
				var residue = duration * 1000 - serverTime.getTime(); // 倒计时
			}
			return residue;
		},
		// 时间戳时分秒
		toHHmmss(data) {
			let date = {};
			let hours = parseInt((data % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			let minutes = parseInt((data % (1000 * 60 * 60)) / (1000 * 60));
			let seconds = (data % (1000 * 60)) / 1000;
			date.hours = hours;
			date.minutes = minutes;
			date.seconds = seconds;
			return date;
		},
		// 选择操作
		getIputValue(itemse, itms, alli, soni) {
			let dataLists = Array.from(this.dataLists);
			let putvalues = JSON.parse(JSON.stringify(itms));
			let answermoadobj = {};

			if (itemse.SQT_Name == '判断题') {
				dataLists.forEach((item, index) => {
					item.Questionoptions.forEach((itm, idx) => {
						// console.log(putvalues.SQO_GUID, itm.SQO_GUID);
						if (putvalues.SQO_GUID == itm.SQO_GUID && putvalues.value == itm.value) {
							itm.isOptionAnswer = 1;
							item.isopsanswers = 1;

							if (idx == 0) {
								item.Questionoptions[1].isOptionAnswer = 0;
							} else {
								item.Questionoptions[0].isOptionAnswer = 0;
							}
						}
					});
				});

				answermoadobj.SQB_GUID = itemse.SQB_GUID;
				answermoadobj.SQO_GUID = itms.SQO_GUID;
				answermoadobj.SQT_TYPE = itemse.topicType;
				answermoadobj.SQT_GUID = itemse.SQT_GUID;
				answermoadobj.SQO_IsChecked = itms.value == 'A' ? '1' : '0';
				answermoadobj.numstrst = alli + 1;
				dataLists[alli].answermoadobj = answermoadobj;
			} else if (itemse.SQT_Name == '多选题') {
				if (dataLists[alli].Questionoptions[soni].isOptionAnswer == 1) {
					dataLists[alli].Questionoptions[soni].isOptionAnswer = 0;
				} else {
					dataLists[alli].Questionoptions[soni].isOptionAnswer = 1;
				}
				dataLists[alli].isopsanswers = 1;
				let isnums = 0;
				dataLists[alli].Questionoptions.forEach(sonitem => {
					if (sonitem.isOptionAnswer == 0) {
						isnums += 1;
						// console.log(isnums)
					}
				});
				if (isnums >= dataLists[alli].Questionoptions.length) {
					dataLists[alli].isopsanswers = 0;
				}
				let answrlistqust = [];
				dataLists[alli].Questionoptions.forEach(lb => {
					if (lb.isOptionAnswer == 1) {
						answrlistqust.push(lb.SQO_GUID);
					}
				});

				dataLists[alli].answrlistqust = Array.from(new Set(answrlistqust)).join(',');

				answermoadobj.SQB_GUID = itemse.SQB_GUID;
				answermoadobj.SQO_GUID = dataLists[alli].answrlistqust;
				answermoadobj.SQT_TYPE = itemse.topicType;
				answermoadobj.SQT_GUID = itemse.SQT_GUID;
				answermoadobj.SQO_IsChecked = '';

				dataLists[alli].answermoadobj = answermoadobj;
			} else if (itemse.SQT_Name == '单选题') {
				dataLists[alli].Questionoptions.forEach(ptionitem => {
					ptionitem.isOptionAnswer = 0;
				});
				dataLists[alli].isopsanswers = 1;
				dataLists[alli].Questionoptions[soni].isOptionAnswer = 1;

				answermoadobj.SQB_GUID = itemse.SQB_GUID;
				answermoadobj.SQO_GUID = itms.SQO_GUID;
				answermoadobj.SQT_TYPE = itemse.topicType;
				answermoadobj.SQT_GUID = itemse.SQT_GUID;
				answermoadobj.SQO_IsChecked = '';
				answermoadobj.inchared = itms.value;
				answermoadobj.numstrst = alli + 1;

				dataLists[alli].answermoadobj = answermoadobj;
			}

			// this.radio
			let radio = [];
			dataLists.forEach(itrdio => {
				if (itrdio.isopsanswers == 1) {
					radio.push(itrdio);
				}
			});
			this.radio = radio;
			this.$nextTick(() => {
				this.dataLists = dataLists;
			});
		}
	},
	beforeRouteEnter(to, from, next) {
		next(() => {
			// 改变html背景
			document.querySelector('html').style.cssText = `
	        background: #ecf1f6;
	      `;
		});
	},
	beforeRouteLeave(to, from, next) {
		// 消除html背景
		document.querySelector('html').style.cssText = `background: #fff;`;
		// 中途退出提示
		if (this.iseaminmroe) {
			this.$confirm('确定中途退出吗, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					next();
				})
				.catch();
		} else {
			next();
		}
	},
	components: {
		Header,
		Time
	}
};
</script>

<style scoped lang="less">
.headers {
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 999;
}

.answersqust {
	display: flex;
	align-items: center;
	margin-left: 30px;
	margin-bottom: 10px;
	cursor: pointer;
	.clicrs {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		border: 1px solid #ccc;
		margin-right: 10px;
		text-align: center;
	}
}

.exminrlist {
	width: 100%;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	.exminritems {
		border: 1px solid #ccc;
		padding: 20px;
		width: 46%;
		margin-right: 2%;
		box-sizing: border-box;
		border-radius: 10px;
		margin-bottom: 10px;
		cursor: pointer;
		border-top: 5px solid;

		.exminrp {
			margin-bottom: 10px;
			font-size: 18px;
		}
	}
}

/deep/ .el-progress__text {
	display: none;
}
/deep/ .el-select .el-input__inner:focus {
	border-color: #55b6da;
}
/deep/ .el-select {
	border: none;
}
/deep/ .el-select-dropdown__item.selected {
	color: #55b6da !important;
	font-weight: bold;
}
/deep/ .el-radio__input.is-checked + .el-radio__label {
	color: #55b6da;
}
/deep/ .el-radio__input.is-checked .el-radio__inner {
	border-color: #55b6da;
	background: #55b6da;
}
/deep/ .el-radio__inner:hover {
	border-color: #55b6da;
}
/deep/ .el-radio {
	display: block;
	margin: 20px 0;
}
.inner {
	padding: 0px 90px;
}
.exam {
	background: #ecf1f6;
	height: 100%;
	min-height: 100%;
}
.main {
	.header-wrapper {
		height: 80px;
		width: 100%;
		line-height: 80px;
		background: #ffffff;
		box-shadow: 0 2px 4px 0 rgba(153, 153, 153, 0.1);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 1040;
		.left {
			display: flex;
			align-items: center;
			font-size: 18px;
			.logo {
				width: 150px;
				margin-right: 120px;
				img {
					width: 100%;
				}
			}
		}
		.right {
			div {
				float: right;
				font-size: 16px;
			}
			.esc {
				width: 120px;
				height: 38px;
				line-height: 38px;
				margin: 21px 0;
				color: #fff;
				background: #55b6da;
				border-radius: 30px;
				text-align: center;
				cursor: pointer;
				user-select: none;
				&:hover {
					filter: brightness(80%);
				}
				&:active {
					filter: brightness(60%);
				}
			}
			.name {
				margin-right: 55px;
				font-weight: bold;
			}
		}
	}
	.mian-body {
		.main-side {
			display: inline-block;
			height: calc(100% - 140px);
			position: fixed;
			top: 120px;
			width: 240px;
			left: 90px;
			background: #fff;
			box-shadow: 0 1px 4px 0 rgba(58, 62, 81, 0.1);
			.title {
				position: relative;
				text-align: left;
				margin: 23px 0px 0px 12px;
				.title_border {
					display: inline-block;
					width: 4px;
					height: 26px;
					background: #33394b;
					border-radius: 15px;
					position: absolute;
					top: 0;
					bottom: 0;
					margin: auto;
				}
				.title_content {
					margin-left: 14px;
					font-size: 18px;
					font-weight: 600;
					color: #27274a;
				}
			}
			.card-content-list {
				height: calc(100% - 38px);
				overflow: auto;
				.card-content {
					padding: 0 12px 0 12px;
					position: relative;
					.card-content-title {
						font-size: 14px;
						color: #27274a;
						font-weight: 600;
						padding-bottom: 12px;
						padding-top: 20px;
					}
					.box-list {
						padding-bottom: 0;
						position: relative;
						left: -5px;
						font-size: 0;
						margin-right: -15px;
						.box {
							height: auto;
							line-height: unset;
							position: relative;
							margin-bottom: 15px;
							font-size: 14px;
							width: 35px;
							margin-top: unset;
							margin-right: unset;
							display: inline-block;
							.checki {
								border: 1px solid #dcdfe6;
								color: #dcdfe6;
								width: 27px;
								height: 27px;
								text-align: center;
								display: inline-block;
								line-height: 27px;
								background: #fff;
								border-radius: 50%;
								cursor: pointer;
							}
							.checked {
								color: #fff;
								background: #55b6da;
							}
							.check-error {
								color: #fff;
								background: #ec6941;
							}
						}
					}
				}
			}
		}
		.main-center {
			margin: 75px 230px 0px 360px;
			height: 100vh;
			.body-wrapper {
				color: #27274a;
				width: 100%;
				background: #ffffff;
				border: 1px solid #dedede;
				border-radius: 4px;
				.questions-title {
					font-size: 18px;
					line-height: 25px;
					padding: 18px 20px;
					background: #fafafa;
					border-bottom: 1px solid #dedede;
				}
				.questions-content {
					padding-left: 30px;
					padding-right: 75px;
				}
				.question-content {
					border-bottom: 1px solid #dedede;
					padding: 15px 0;
					position: relative;
					&:last-child {
						border: none;
					}
					.exam-question {
						font-size: 16px;
						line-height: 22px;
						margin-bottom: 10px;
						padding-left: 20px;
						position: relative;
						// display: flex;

						p.exam-dxtt {
							background-color: #55b6da;
						}

						p.exam-dxt {
							background-color: #55aaff;
						}

						p {
							background: red;
							color: #fff;
							border-radius: 10px;
							margin: 0 10px;
							height: 16px;
							width: 75px;
							line-height: 16px;
							font-size: 12px;
							text-align: center;
							display: inline-block;
						}

						.question-index {
							color: #55b6da;
							position: absolute;
							left: -25px;
							top: 0;
							display: inline-block;
							width: 40px;
							line-height: 22px;
							text-align: right;
						}
					}
					.analysis {
						overflow: auto;
						background: rgba(222, 222, 222, 0.2);
						border-radius: 4px;
						padding: 15px 20px;
						line-height: 24px;
						margin-top: 10px;
						position: relative;
						.question-icon-wrapper {
							position: absolute;
							right: 10px;
							top: 14px;
							.sign {
								width: 48px;
								height: 28px;
								position: absolute;
								color: #fff;
								top: 10px;
								right: 0;
								font-size: 14px;
								border-radius: 2px;
								line-height: 28px;
								text-align: center;
								font-style: normal;
							}
							.icon-error {
								background: #ec6941;
							}
							.icon-right {
								background: #55b6da;
							}
						}
						.analysis-row {
							font-size: 14px;
							margin-top: 10px;
							min-height: 24px;
							padding-left: 80px;
							padding-right: 60px;
							position: relative;
							.analysis-title {
								position: absolute;
								width: 80px;
								left: 0;
								top: 0;
							}
							.question-analysis {
								text-align: justify;
							}
							.error {
								color: #f72a3a;
								font-weight: bold;
							}
						}
					}
				}
			}
		}
		.main-right {
			right: 90px;
			bottom: 20px;
			position: fixed;
			top: 120px;
			width: 120px;
			.nav {
				color: #27274a;
				line-height: 20px;
				padding: 0 10px;
				background: #ffffff;
				box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
				border-radius: 4px;
				margin-bottom: 10px;
				text-align: center;
				.menu-item {
					padding: 14px 0;
					border-bottom: 1px solid #dedede;
				}
				.menu-item:last-child {
					border: none;
				}
				.pass {
					color: #55b6da;
				}
				.item-result,
				.unpass {
					color: rgb(236, 105, 65);
				}
				.item-label {
					margin-bottom: 6px;
				}
				.item-data {
					font-size: 18px;
					line-height: 22px;
					color: #ff0000;
					font-weight: 400;
				}
				.item-press {
					line-height: 17px;
					margin-bottom: 7px;
					color: #27274a;
					font-size: 14px;
					& span:nth-child(1)::after {
						content: '/';
						margin: 0 5px;
					}
				}
			}
			.btn {
				bottom: -10px;
				position: absolute;
				width: 100%;
				margin-bottom: 10px;
				cursor: pointer;
				text-align: center;
				height: 38px;
				line-height: 22px;
				border-radius: 20px;
				color: #fff;
				background: #33394b;
				user-select: none;
				&:hover {
					width: 120%;
				}
			}
		}
	}
}
</style>
